module.exports = __webpack_public_path__ + "static/media/flag.8437a00b.svg";